import { useContext } from 'react';
import AuthContext from 'src/contexts/AmplifyContext';

const useAuth = () => useContext(AuthContext);

export default useAuth;
